import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers'
import { WCAG } from "rytm-wcag"
import { windowUpdate, removeReCaptchaBadge } from './shared/common'
import { viewAppend, viewRemove } from './tsaw/actions/actions_router'
import { stopSoundBg, stopSoundOverlay } from './tsaw/actions/actions_audio'
// controllers
import Controller from './controllers/Controller'
import ChapterSoundController from './controllers/ChapterSoundController'
// views
import BasicView from './views/BasicView'
import BasicBgView from './views/BasicBgView'
import ContentView from './views/ContentView'
import ListView from './views/ListView'
import FromTopView from './views/FromTopView'
import FromBottomView from './views/FromBottomView'
import CharacterContentView from './views/CharacterContentView'
import { resetVideoInterfaceCounter, resetVideoLoopCounter } from './tsaw/lib/tsaw_video'

const routes = {
  'basic': {
    controller: Controller,
    view: BasicView
  },
  'basic_bg': {
    controller: Controller,
    view: BasicBgView
  },
  'list': {
    controller: Controller,
    view: ListView
  },
  'content': {
    controller: Controller,
    view: ContentView
  },
  'from_top': {
    controller: Controller,
    view: FromTopView
  },
  'from_bottom': {
    controller: Controller,
    view: FromBottomView
  },
  'character_content': {
    controller: Controller,
    view: CharacterContentView
  },
  'chapter_sound': {
    controller: ChapterSoundController,
    view: BasicView
  },
}
const aswapProps = {
  animationTimeHide: 900,
  animationTimeShow: 900,
  preloadOnHover: false,
  refreshOnSameUrl: false,
  cacheOn: true,
  routes,
  trace,
}
const aswapEvents = {
  onViewSwapStart: () => {
    // previous stage inner
    const container = document.getElementById("stage-inner")
    viewRemove(RytmWebflow.aswap?.dispatcher?.prevUrl, container)
  },
  onViewSwapComplete: () => {
    WCAG.onViewChanged()
    windowUpdate()
    RytmWebflow.showUp.rebuild()
    // tsaw state view change
    const container = document.getElementById("stage-inner")
    viewAppend(RytmWebflow.aswap?.dispatcher?.currentUrl, container)
    // video interface hide counter reset
    resetVideoInterfaceCounter()
    resetVideoLoopCounter()
  },
  onViewHide: () => {
    WCAG.dialogCloseAll()
    removeReCaptchaBadge()
    RytmWebflow.showUp.hide()
    RytmWebflow.bootsrap5.hideFlyovers()
    stopSoundBg()
    stopSoundOverlay()
    // video interface hide counter reset
    resetVideoInterfaceCounter()
  },
  onViewHidden: () => {
    // destroy...
    // video interface hide counter reset
    resetVideoInterfaceCounter()
  },
  onViewShown: () => {
    // video interface hide counter reset
    resetVideoInterfaceCounter()
  }
}

export const initASwap = () => {
  RytmWebflow.aswap.init(aswapProps, aswapEvents)
}